import { Button } from "reactstrap";

export const AddButton = ({ toggleModalState, action = () => {} }) => (
  <Button
    onClick={() => {
      toggleModalState(true);
      action();
    }}
  >
    Inserimento
  </Button>
);
